import Battery0BarTwoToneIcon from '@mui/icons-material/Battery0BarTwoTone'
import Battery6BarTwoToneIcon from '@mui/icons-material/Battery6BarTwoTone'
import BatteryChargingFullTwoToneIcon from '@mui/icons-material/BatteryChargingFullTwoTone'
import BatterySaverTwoToneIcon from '@mui/icons-material/BatterySaverTwoTone'
import * as React from 'react'
import dataStore from '../../../store/dataStore.ts'
import { IDevice, IPet } from '../../../interfaces/types.ts'
import { SubItem } from './SubItem.tsx'

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faBattery } from '@fortawesome/free-solid-svg-icons/faBattery'
// import { faBolt } from '@fortawesome/free-solid-svg-icons/faBolt'

interface Props {
    pet: IPet
    mini?: boolean
    mobile?: boolean
    dashboard?: boolean
    iconOnly?: boolean
}

const getIcon2 = (on: boolean, charging: boolean, beacon: boolean, percent: number, mobile: boolean) => {
    const style = mobile ? {
        height: '33.5px',
        width: '33.5px',
        border: '2.25px white solid'
    } : {
        height: '40px',
        width: '40px',
        border: '2px white solid'
    }

    const color = percent === 0 ? 'disabled'
        : percent < 21 ? 'error'
            : percent < 51 ? 'warning'
                : 'success'

    const icon = charging ?
        <BatteryChargingFullTwoToneIcon
            fontSize={'large'}
            color={color}
        />
        : !on ?
            <Battery0BarTwoToneIcon
                fontSize={'large'}
                color={'disabled'}
            />
            : beacon ?
                <BatterySaverTwoToneIcon
                    fontSize={'large'}
                    color={color}
                />
                : <Battery6BarTwoToneIcon
                    fontSize={'large'}
                    color={color}
                />
    return (
        <div className={'rounded-full p-[1px] bg-white'} style={style}>
            {icon}
        </div>
    )
}

export const Battery = (props: Props) => {
    const {pet, mobile, iconOnly} = props
    const [status, setStatus] = React.useState('')
    const [icon, setIcon] = React.useState<React.ReactNode | null>(null)
    const [color, setColor] = React.useState<any>('inherit')
    const [percent, setPercent] = React.useState('-')
    const [device, setDevice] = React.useState<IDevice | null>(null)
    const [isOff, setIsOff] = React.useState(false)

    const devices = dataStore((s) => s.devices)

    React.useEffect(() => {
        if (devices) {
            const dev = devices.find(d => d.petId === pet._id)
            if (dev) {
                let color = 'success'
                let percent = '-'
                if (dev) {
                    setDevice(dev)
                    percent = dev.status.batteryPercent
                    if (!dev.status.powerOn) {
                        setStatus('off')
                        color = 'black'
                        setIsOff(true)
                        setStatus('off')
                        percent = 'off'
                    } else {
                        setIsOff(false)
                    }
                    if (dev.status.charging) {
                        setStatus('charging')
                        color = 'info'
                    } else if (dev.status?.batteryAlert) {
                        setStatus('low')
                        color = 'error'
                    } else {
                        setStatus('on')
                    }
                    let val = 0
                    if (!isOff) {
                        val = parseFloat(percent)
                        // console.log('battery val', val)
                        if (color !== 'info') {
                            if (color !== 'black' && val >= 50 && val <= 100) {
                                color = 'success'
                            }
                            if (val < 50 && val >= 20) {
                                color = 'warning'
                            }
                            if (val < 20) {
                                color = 'error'
                            }
                        }
                        // console.log('color', color)
                    }
                    setPercent(percent)
                    // setIcon(getIcon(dev.status, color, val, dashboard, Boolean(mobile)))
                    const _percent = !isOff ? parseFloat(percent) : 0
                    setIcon(getIcon2(dev.status.powerOn, dev.status.charging, dev.status.beaconInRange, _percent, Boolean(mobile)))
                    setColor(color !== 'info' ? `text-${color}` : 'text-primary')
                }
            }
        }
    }, [devices, pet])

    const subItem = (
        <SubItem pet={pet} title={'Battery'}
                 icon={icon} className={'-ml-1 -mr-2'} mobile={mobile}>
            <div className={'flex items-center justify-between'}>
                <div className={`${color} font-md text-lg`}>
                    {!isOff ? <span> Battery at <span className={'font-semibold'}>{percent}</span></span> :
                        <span className={'font-semibold'}>Off</span>}
                </div>

                <div className={`text-md ${color}`}>
                    Tracker is {status}
                </div>
            </div>
        </SubItem>
    )

    const batteryIcon = (
        <div className={'grid grid-rows-2 gap-1'}>
            <div className={'justify-self-center'}>{icon}</div>
            <div className={'bg-transparent text-primary-contentjustify-self-center'}>{percent}</div>
        </div>
    )
    return device ? iconOnly ? batteryIcon : subItem : null
}
